var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-tab-left",
    clipPath: "url(#clip0_2687_338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.5C0 3.08579 0.335786 2.75 0.75 2.75H15.25C15.6642 2.75 16 3.08579 16 3.5C16 3.91421 15.6642 4.25 15.25 4.25H0.75C0.335786 4.25 0 3.91421 0 3.5ZM0 8C0 7.58579 0.335786 7.25 0.75 7.25H13.25C13.6642 7.25 14 7.58579 14 8C14 8.41421 13.6642 8.75 13.25 8.75H0.75C0.335786 8.75 0 8.41421 0 8ZM0.75 11.75C0.335786 11.75 0 12.0858 0 12.5C0 12.9142 0.335786 13.25 0.75 13.25H11.25C11.6642 13.25 12 12.9142 12 12.5C12 12.0858 11.6642 11.75 11.25 11.75H0.75Z",
    fill: "#4D1DF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2687_338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTickets);
export default __webpack_public_path__ + "static/media/all_tickets.33851eb65287e24ef5f7102802932de3.svg";
export { ForwardRef as ReactComponent };